import React from "react";
import {
  TableRow,
  TableCell,
  withStyles,
  TableFooter,
} from "@material-ui/core";
import Message from "./components/Message";
import DriverStatus from "./components/DriverStatus";
import NextStop from "./components/NextStop";

const colors = {
  tableRowRootBackground: "#F0F0F0",
  footerDark: "525F6D",
};
const styles = {
  containerLight: {
    backgroundColor: colors.tableRowRootBackground,
  },
  containerDark: {
    backgroundColor: colors.footerDark,
  },
  tableRowRoot: {
    height: "25px",
    verticalAlign: "top",
  },
  driverDetails: {
    display: "flex",
    alignItems: "center",
    float: "right",
  },
  labelCell: {
    width: "50%",
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    paddingTop: 7,
    lineHeight: "14px",
    wordBreak: "break-all",
  },
  dualCellLeft: {
    display: "inline-block",
  },
  dualCellRight: {
    display: "inline-block",
    paddingLeft: "10px",
  },
  dataCellPickupInfo: {
    borderBottom: 0,
    paddingTop: 7,
    fontSize: 10,
    width: "80px",
    "&$lastTableCell": {
      paddingRight: 10,
      paddingTop: 7,
    },
  },
  lastRow: {
    paddingBottom: "7px",
  },
  lastTableCell: {},
};
const Footer = ({
  classes,
  theme,
  driverDetails,
  stopData,
  openDriverChat,
}) => {
  const openMessageChatBox = (event) => {
    openDriverChat?.(event, driverDetails.driverId);
  };
  return (
    <TableFooter
      className={
        theme === "dark" ? classes.containerDark : classes.containerLight
      }
    >
      <TableRow className={classes.tableRowRoot}>
        <TableCell
          className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}
        >
          {driverDetails.driverName}
        </TableCell>
        <TableCell
          align="right"
          className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} tableCellValue`}
        >
          <div className={classes.driverDetails}>
            {openDriverChat && <Message onClick={openMessageChatBox} />}
            {`#${driverDetails.driverNumber}`}
          </div>
        </TableCell>
      </TableRow>

      {driverDetails.nextStopDetails && (
        <TableRow className={classes.tableRowRoot}>
          <TableCell
            className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}
          >
            <div className={classes.dualCellLeft}>Next Stop</div>
          </TableCell>

          <TableCell
            align="right"
            className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} tableCellValue`}
          >
            <NextStop nextStopDetails={driverDetails.nextStopDetails} />
          </TableCell>
        </TableRow>
      )}

      <TableRow className={classes.tableRowRoot}>
        <TableCell
          className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastRow} tableCellName`}
        >
          <div className={classes.dualCellLeft}>Current Status</div>
        </TableCell>
        <TableCell
          align="right"
          className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} ${classes.lastRow} tableCellValue`}
        >
          <DriverStatus
            driverStatusDetails={driverDetails.driverStatusDetails}
            currentStop={stopData}
            theme={theme}
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default withStyles(styles)(Footer);
